import { render } from "./PlayerFeedback.vue?vue&type=template&id=383748f6"
import script from "./PlayerFeedback.vue?vue&type=script&lang=js"
export * from "./PlayerFeedback.vue?vue&type=script&lang=js"

import "./PlayerFeedback.vue?vue&type=style&index=0&id=383748f6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__